const chikooPulpData = {
  hero_section: {
    title: "Premium Chikoo (Sapota) Pulp Collection",
    description: "100% Natural • No Preservatives • Natural Caramel Sweetness",
    src: "videos/chikoo-processing.webm",
  },
  description: {
    title: "Premium Chikoo (Sapota) Pulp Collection",
    main_description:
      "Discover our range of 100% natural chikoo pulp, crafted from the finest sapota fruits to preserve the authentic caramel-like sweetness and smooth texture.",
    segment_description:
      "Perfect for desserts, beverages, and specialty food applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Chikoo (Sapota) Pulp",
    description: "Our chikoo pulp captures the unique caramel-like sweetness and smooth texture of this beloved fruit. Perfect for desserts, beverages, and specialty applications requiring natural sweetness.",
    image: "New-Images/Chikkoo.png",
    mainFeatures: [
      "Natural caramel-like sweetness",
      "Smooth, creamy texture",
      "Rich flavor profile",
      "Perfect for desserts",
      "Traditional favorite",
      "Consistent quality and taste"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "121",
      fat: "1g (Sat. fat: 0.35g)",
      carbs: "22g (Sugar: 21g, Added: 10g)",
      fiber: "9g",
      protein: "<1g",
      sodium: "5mg",
      potassium: "252mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Premium Chikoo Pulp",
      image: "New-Images/Chikkoo.png",
      features: [
        "Natural caramel sweetness",
        "Smooth texture",
        "Rich flavor",
        "Perfect for desserts"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Chikoo Pulp Excellence",
    description: "Our chikoo pulp is processed from the finest handpicked sapota fruits using advanced processing techniques. We maintain strict quality control to ensure consistent sweetness, texture, and flavor in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Sweet Applications",
    subline: "From desserts to beverages – natural caramel sweetness in every application!",
    description:
      "Ideal for dessert manufacturers, beverage producers, confectionery makers, and food service providers who value natural sweetness and authentic flavors.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "dessert-applications.webp",
      title: "Dessert Applications",
      description:
        "Perfect for ice creams, puddings, sweets, and confectionery products with natural caramel sweetness.",
    },
    {
      id: 2,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Ideal for milkshakes, smoothies, and specialty drinks requiring natural sweetness and flavor.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Food Service Applications",
      description:
        "Excellent for restaurants, cafes, and dessert parlors offering traditional and modern chikoo-based treats.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural chikoo goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Natural Sweetness",
      image: "natural-sweetness.webp",
      title: "Natural Sweetness",
      description:
        "Preserving the natural caramel-like sweetness without artificial additives",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Chikoo Pulp",
    description: "Discover the perfect blend of natural sweetness and quality that makes our chikoo pulp the preferred choice for dessert and beverage manufacturers worldwide.",
  },
};

export default chikooPulpData;
